import Joi from 'joi';
import api from '../api';
import { paginationSchema } from '../cortizol/schemas';

/**
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @returns {Promise<{data: {garageExclusions: GarageExclusion[], pagination: Pagination}}>}
 */
export const getGarageExclusionsList = async (queryParams) => {
  const result = await api.get('/old-tires/v1-0/garage-exclusions', { params: queryParams });

  try {
    const garageExclusionSchema = Joi.object({
      id: Joi.string().required(),
      googleBusinessId: Joi.string().required(),
      exclusionReason: Joi.string().valid(
        'notConcerned',
        'notConsentedToAddressUsage',
        'professionalRefusedTires',
        'professionalNotFoundAtAddress',
      ).required(),
      requestedBy: Joi.string().valid('private', 'professional').required(),
      isVisible: Joi.boolean().required(),
      isTreated: Joi.boolean().required(),
      garageName: Joi.string().allow(null, ''),
      garageStreetNumber: Joi.string().allow(null, ''),
      garageStreetName: Joi.string().allow(null, ''),
      garagePostalCode: Joi.string().allow(null, ''),
      garageCity: Joi.string().allow(null, ''),
      garagePhoneNumber: Joi.string().allow(null, ''),
    });

    const schema = Joi.object({
      garageExclusions: Joi.array().items(garageExclusionSchema).required(),
      pagination: paginationSchema,
    });

    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response does not match Garage Exclusions List Schema: ${error.message}`);
  }

  return result.data;
};

/**
 * Reintegrate a garage on the map.
 * @param {string} garageId - The garage ID in UUID format.
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const postReintegrateGarage = async (garageId) => api.post(
  `/old-tires/v1-0/garage-exclusions/${garageId}:reintegrate`,
);

/**
 * Exclude a garage.
 * @param {string} garageId - The garage ID in UUID format.
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const postExcludeGarage = async (garageId) => api.post(
  `/old-tires/v1-0/garage-exclusions/${garageId}:exclude`,
);
